import PropTypes from 'prop-types';

export const MENU_TYPES = {
  DASHBOARD: 'dashboard',
  ACADEMY: 'academy',
  MARKETPLACE: 'marketplace',
  DYNAMIC: 'dynamic',
};

const propType = {
  type: PropTypes.string.isRequired,
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
  newTab: PropTypes.bool,
  translations: PropTypes.object,
};

export default { propType };
